export default function masonryCardsDouble(widgetNameVariable, widgetOptsVariable, maxItems) {
  const widgetName = widgetNameVariable;
  const widgetOpts = widgetOptsVariable;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    maxItemsVisible: maxItems,
    itemsPerPanel: 6,
    showDescription: false,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createGallery(data.items);
        $widget.find('.buttonwrap a').addClass('button');
      } else {
        $widget.remove();
      }
    },
  });

  // ****************************************************************
  // Function Helpers
  function createGallery(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { URL } = widgetData[x];
      const $card = $(this);

      if (!URL) {
        $card.removeAttr('href');
      }
    });
  }
}
